import { formatMinutes } from '@/utils/date'

export const SCHEDULE_START_MINUTES = 480
export const SCHEDULE_END_MINUTES = 1200
export const SCHEDULE_STEP_MINUTES = 30

export const TIME_OPTIONS: Array<{ label: string; value: number }> = (() => {
  const opts = []
  for (
    let mins = SCHEDULE_START_MINUTES;
    mins <= SCHEDULE_END_MINUTES;
    mins += SCHEDULE_STEP_MINUTES
  ) {
    opts.push({ label: formatMinutes(mins), value: mins })
  }
  return opts
})()
